import { supabase } from '../../../src/lib/supabase';
import { limparUc, mesReferenciaParaOrdinal, normalizarMesReferencia } from './consumoHistorico';

export interface GeracaoFaturaResultado {
  geracaoKwh: number;
  mesReferenciaFatura: string;
}

const SLOTS = [1, 2, 3, 4, 5] as const;

/**
 * Busca a geração real extraída da fatura PRÓPRIA da UG (medidor de
 * injeção dela mesma) — bloco SCEE autorreferenciado: unidade_geradora_N
 * igual ao próprio uc_codigo, geracao_unidade_geradora_N = quanto gerou
 * naquele ciclo. Reaproveita o mesmo padrão de normalização de UC
 * (limparUc) já usado em buscarHistoricoConsumoUcs — faturas.uc_codigo já
 * é gravado limpo (sem pontos/traços/zeros à esquerda) pelo mapeador.
 * Retorna null se a fatura própria dessa UG ainda não foi extraída (não é
 * erro — Gestão > Extração de Faturas precisa rodar pelo menos uma vez).
 */
export async function buscarGeracaoFaturaUg(numeroUcGeradora: string): Promise<GeracaoFaturaResultado | null> {
  const codigoLimpo = limparUc(numeroUcGeradora);
  if (!codigoLimpo) return null;

  const colunasUg = SLOTS.map(n => `unidade_geradora_${n}`).join(', ');
  const colunasGeracao = SLOTS.map(n => `geracao_unidade_geradora_${n}`).join(', ');

  const { data, error } = await supabase
    .from('faturas')
    .select(`uc_codigo, mes_referencia, ${colunasUg}, ${colunasGeracao}`)
    .eq('uc_codigo', codigoLimpo);
  if (error) throw error;
  if (!data || data.length === 0) return null;

  const maisRecente = [...data].sort(
    (a: any, b: any) =>
      (mesReferenciaParaOrdinal(b.mes_referencia) ?? -1) - (mesReferenciaParaOrdinal(a.mes_referencia) ?? -1)
  )[0] as any;

  for (const n of SLOTS) {
    const ugCodigo = maisRecente[`unidade_geradora_${n}`];
    if (!ugCodigo || limparUc(ugCodigo) !== codigoLimpo) continue;
    const geracao = maisRecente[`geracao_unidade_geradora_${n}`];
    if (geracao == null) continue;
    return { geracaoKwh: geracao, mesReferenciaFatura: normalizarMesReferencia(maisRecente.mes_referencia) };
  }

  return null;
}
